import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ValidationService } from '../../shared/providers/validation.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { collapseColumns } from '../../shared/models/collapseColumns';
import { CommonService } from '../../shared/providers/common.service';
import { PermissionService } from '../../shared/providers/permission.service';
import { Actions, Modules } from '../../shared/enum/enum';

export interface IFlaggedList {
  CapRate: string;
  RemainingLeaseTerm: string;
  AskingPrice: string;
  PropertyTypes: string;
  LeaseTerm: string;
  GeographyType: string;
  Subcategories: string;
  States: string;
  SelectedTenants: string;
  Name: string;
  Email: string;
  PhoneNumber: string;
  CompanyName: string;
  Guid: string;
  Id: number;
  CapRateMax: number;
  CapRateMin: number;
  Askingpricemin: number;
  Askingpricemax: number;
}

@Component({
  selector: 'app-InterestCriteriaListing',
  templateUrl: './InterestCriteriaListing.component.html',
})
export class InterestCriteriaListingComponent implements OnInit {
  Modules = Modules;
  Actions = Actions;
  dtOptions = {};
  flaggedList: IFlaggedList[];
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  rowCount = 0;
  public currentpage: string = 'Buyer Criteria';
  public currenturl = '/InterestCriteriaListing';
  canViewCriteria = false;
  constructor(private http: HttpClient, public Validation: ValidationService, private permissionService: PermissionService, public authService: AuthenticationService, private activatedRoute: ActivatedRoute, public router: Router, private modalService: BsModalService, public commonService: CommonService) {

  }
  user: any;
  public Isinit: number = 0;
  IsLoading = false;
  ngOnInit() {
    this.canViewCriteria = this.permissionService.hasPermission(Modules.BuyerCriteria, Actions.Details);
    this.BindColumns();
    this.user = this.authService.user;
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      "pageLength": 50,
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "order": [[0, "asc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        const filter =
        {
          LoggedInUserId: this.user.Id
        }
        dataTablesParameters.Extra_param = filter;
        const httpHeader = this.Validation.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/user/InterestCriteriaListings',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.flaggedList = resp.data ? resp.data : [];
            this.rowCount = resp.data ? resp.data.length : 0;
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
      },
      columns: [
        { data: 'Name' },
        { data: 'CompanyName' },
        { data: 'SelectedTenants' },
        { data: 'States' },
        { data: 'AskingPrice' },
        { data: 'CapRate' },
        { data: 'RemainingLeaseTerm' },
        { data: 'PropertyTypes' },
        { data: 'LeaseTerm' },
        { data: 'GeographyType' },
        { data: 'Subcategories' },

      ]
    };
  }

  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  selectedColumns = [];
  //defaultTypeText: IMultiSelectTexts = {
  //    defaultTitle: 'Select Columns',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select Columns",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  }

  hideColumn(col: number) {

    if (this.selectedColumns.indexOf(col) > -1) {
      return false; // show
    }
    else {
      return true; // hide
    }
  }
  tableColumns: collapseColumns[] = [];
  BindColumns() {
    this.tableColumns = [
      { id: 1, name: 'Company' },
      { id: 2, name: 'Tenants' },
      { id: 3, name: 'States' },
      { id: 4, name: 'Asking Price' },
      { id: 5, name: 'Cap Rate' },
      { id: 6, name: 'Remaining Lease Term' },
      { id: 7, name: 'Property Types' },
      { id: 8, name: 'Lease Structure' },
      { id: 9, name: 'Regions' },
      { id: 10, name: 'Sub-Category' },

    ]
    this.selectedColumns = [];
    if (localStorage.getItem("interest_listings_selectedColumns_LS") !== null) {
      this.selectedColumns = JSON.parse(localStorage.getItem("interest_listings_selectedColumns_LS"));
    }
    else {
      this.tableColumns.forEach(item => {
        if (item.id <= 7) {
          this.selectedColumns.push(item.id);
        }
      });
    }
  }

  onRedirection() {
    localStorage.setItem("interest_listings_selectedColumns_LS", JSON.stringify(this.selectedColumns));
  }

  GetPropertyTypeWithCount(propertyType: any) {
    var result = '';
    if (propertyType) {
      var type = propertyType.split(',')
      var count = type.length - 1;
      result = type[0] + (count > 0 ? ', ' + count + '+' : '');
    }
    return result;
  }
}






